module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0117.jpg?v=d4f2bce8";